import { get, merge, mergeWith, isArray } from 'lodash';
import { getType } from 'typesafe-actions';

import { signOut, updateEntities } from '@lib/actions';
import { RESFRESH_CURRENT_USER } from 'containers/App/constants';

const initialState = {
  activities: {},
  activityContexts: {},
  appointments: {},
  appointmentTypes: {},
  availabilities: {},
  customWebStyles: {},
  chatActivities: {},
  facilities: {},
  fileUploads: {},
  insurances: {},
  messages: {},
  messageTemplates: {},
  offers: {},
  patientForms: {},
  patientFormTemplates: {},
  patients: {},
  providers: {},
  schedule: {},
  settings: {},
  tokens: {},
  users: {},
  waitlists: {},
  // TODO Remove `usersList` from reducer
  usersList: {},
};

// Updates an entity cache in response to any action with normalized.entities
export default function createEntitiesReducer() {
  return (state = initialState, action) => {
    const entities =
      (action.type === getType(updateEntities) && action.payload) ||
      get(action, 'payload.normalized.entities') ||
      get(action, 'normalized.entities');

    if (entities) {
      return mergeWith({}, state, entities, (dest, src) => (isArray(dest) && isArray(src) ? src : undefined));
    }

    switch (action.type) {
      // SIGN_OUT -> reset state
      case getType(signOut):
        return initialState;
      // TODO: remove workaroud to refresh the current user once other calls use normalizr
      case RESFRESH_CURRENT_USER: {
        const users = merge({}, state.users, {
          [action.user._id]: {
            ...action.user,
          },
        });
        const settings = merge({}, state.settings, {
          [action.user.setting]: {
            ...action.user.settings,
          },
        });
        return merge({}, state, { users }, { settings });
      }
      default:
        return state;
    }
  };
}
